import {createSlice, createAsyncThunk}		from '@reduxjs/toolkit';

import {DashboardState}						from './interface';
import actions 								from './dashboardAction';


const initialState: DashboardState = {
	isLoad: false
};

export const getDashboardApi = createAsyncThunk('dashboard/getDashboardApi', actions.getDashboardApi);


export const Reducer = createSlice({
	name:          'dashboard',
	initialState,
	reducers:      {},
	extraReducers: (builder) => {
		builder
		// --- GET
		.addCase(getDashboardApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getDashboardApi.fulfilled, (state, action) => {
			return ({
				...state,
				isLoad: false,
				data:   action.payload
			});
		});
	}
});

// export const {logout} = Reducer.actions;

export default Reducer.reducer;
